import React, {Component} from 'react';
import {connect} from 'react-redux';
import {injectIntl, defineMessages} from 'react-intl';
import {DestinationInfographicLoader} from './DestinationInfographicLoader';
import {Overview} from './overview/Overview';
import {PriceGraph} from './prices/PriceGraph';
import {Weather} from './weather/Weather';
import {wrapInTest} from '../../common/mvt/utils/mvt';
import {TESTS, getValue} from '../../../utils/abacus';

export const messages = defineMessages({
    title: {
        id: 'module.destination.infographic.heading',
        defaultMessage: 'UNTRANSLATED'
    }
});

const mapStateToProps = (state) => ({
    simpleDestinationName: state.destination.details.simpleName,
    infographic: state.destination.infographic,
    abacus: state.abacus
});

export class DestinationInfographicComponent extends Component {
    render() {
        const {
            intl: {formatMessage},
            simpleDestinationName,
            infographic,
            abacus
        } = this.props;

        const title = formatMessage(messages.title, {
            simpleDestinationName
        });

        if (!infographic) {
            return <DestinationInfographicLoader />;
        }

        const testEnabled = getValue(abacus, TESTS.SLP_2134) === 1;

        const infographicComponent = testEnabled ? (
            <div className="container destination-infographic">
                <h2>{title}</h2>
                <div className="context">
                    <Overview />
                    <PriceGraph />
                    <Weather />
                </div>
            </div>
        ) : null;

        return wrapInTest(abacus, TESTS.SLP_2134, infographicComponent);
    }
}

export const DestinationInfographic = injectIntl(
    connect(mapStateToProps)(DestinationInfographicComponent)
);
export default DestinationInfographic;
